import {
    createProperties,
    type Field,
    Form,
    type FormState,
    type TypeToFields,
} from '@jmvdevelop/svelte-form';

export type EquipementMedicalFormData = {
    youAre: string | null;
    equipmentType: string[];
    services: string | null;
};
type FormData = EquipementMedicalFormData;

export type Fields<TFormValues> = TypeToFields<TFormValues, FormData>;

export const empty: FormData = {
    youAre: null,
    equipmentType: [],
    services: null,
};

export function createFields<TValues>(self: Field<TValues, FormData>): Fields<TValues> {
    return {
        self: self,
        ...createProperties(self, ['youAre', 'equipmentType', 'services'] as const),
    };
}

export function validateEquipementMedical<TRootFormData>(
    _form: Form<TRootFormData, string>,
    _values: FormData,
    _fields: Fields<TRootFormData> | undefined | null,
) {
    return (state: FormState<TRootFormData, string>) => {
        return state;
    };
}
